var _defs, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptaLogoSecondary02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 876.04 347.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 79.07,
    y1: 154.06,
    x2: 286.08,
    y2: 221.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#faa51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f06424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -8.42,
    y1: 126.42,
    x2: 198.19,
    y2: 193.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e07ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#e5202f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Opta"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597.66,125.45q-31.56,0-52.23,8l-10.6,3.88V320.66h39V265.33a105.85,105.85,0,0,0,20.42,2.32q29.73,0,44.73-14.35t15-41.75V179q0-25.84-13.83-39.69T597.66,125.45Zm17.06,86.1q0,21.19-23.53,21.2a113.14,113.14,0,0,1-17.32-1.55V162.42l1.55-.26a63.81,63.81,0,0,1,8.79-1.42q4.39-.39,8.79-.39,21.72,0,21.72,18.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.09,164l11.5-34.65H720.26v-31h-39v31H658V164h23.27v45q0,17.6,3.62,28.83T696,255.63q7.49,6.6,19.52,9.18a137.76,137.76,0,0,0,28.57,2.59h6.16V231.46h-6.16a51.45,51.45,0,0,1-11.25-1,15.3,15.3,0,0,1-7.37-3.75,14.88,14.88,0,0,1-4-7.37,50.55,50.55,0,0,1-1.16-11.89V164Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M818.38,125.45q-40.86,0-55.33,26.89l-3.88,7.5,32.32,13.44,4.14-5.43q7.23-9.56,21.46-9.56,19.9,0,19.91,19.13v5.69q-4.14-.26-8.67-.39c-3-.08-6.25-.13-9.69-.13a151.14,151.14,0,0,0-27.8,2.2q-11.51,2.19-18.61,7.11A28.89,28.89,0,0,0,761.76,205q-3.37,8.14-3.36,20a55.43,55.43,0,0,0,3,19,28.54,28.54,0,0,0,9.82,13.31q6.85,5.18,18.23,7.76t28.18,2.58q33.36,0,48.87-7c.34-.17,1-.47,1.94-.9s2-.91,3.23-1.42q2.07-1,4.4-2.07V180Q876,125.46,818.38,125.45ZM837,236.11l-2.33.26a82.72,82.72,0,0,1-8.27.78q-4.92.25-11.64.25-10.08,0-13.7-3.23t-3.62-9.44q0-5.94,3.75-9.17t14.09-3.24c1,0,2.62.05,4.78.13s4.4.13,6.72.13,4.48,0,6.47.13,3.23.13,3.75.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503,94.71Q483.06,76.4,446.42,76.39q-36.39,0-56.27,18.32t-19.87,51.11V198q0,32.79,19.87,51.11t56.27,18.32q36.65,0,56.53-18.32T522.82,198V145.82Q522.82,113,503,94.71Zm-22.2,104q0,30.2-34.33,30.2-16.51,0-25.29-7.62t-8.78-22.58V145q0-15,8.78-22.58t25.29-7.61q34.32,0,34.33,30.19Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.5,33.36a112.85,112.85,0,0,0-32.86-20.93L185.77,81.31a37.32,37.32,0,0,1,6.91,5c3.56,3.28,13,12,13,40.11V221.3c0,28.12-9.43,36.82-13,40.1-12.8,11.81-36.48,14.29-54.08,14.29a162,162,0,0,1-17.09-.85l-23,69.28a211.85,211.85,0,0,0,40.09,3.57q66.7,0,102.89-33.36t36.18-93V126.39Q277.68,66.72,241.5,33.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85,261.38c-3.54-3.27-13-12-13-40.08V126.39c0-28.12,9.43-36.82,13-40.1C95.27,76.81,113.31,72,138.61,72c5.06,0,10.62.21,16.28.78l23-69.4A215,215,0,0,0,138.61,0Q72.35,0,36.18,33.36T0,126.39V221.3q0,59.67,36.18,93a113,113,0,0,0,31.71,20.48l22.93-69.06A38.24,38.24,0,0,1,85,261.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptaLogoSecondary02);
export default __webpack_public_path__ + "static/media/Opta_Logo_Secondary_02.c876fff25ee9105b24a66b400888f0bc.svg";
export { ForwardRef as ReactComponent };